import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles/index';
const styles = theme => ({
    error: {
        padding: '1px',
        'border-bottom': '.1rem solid red',
    },
    normal: {
        padding: '1px',
        'border-bottom': '1px solid grey',
    }
});
class SelectNative extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.selection || ''
        };
    }
    onChange = (event) => {
        this.setState({ value: event.target.value });
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    };
    render() {
        const { classes, id } = this.props;
        let { options, error, selection, labelProp, codeProp, label, promptText } = this.props;
        if (!promptText) {
            promptText = 'Select...';
        }
        if (!labelProp) {
            labelProp = 'label';
        }
        if (!codeProp) {
            codeProp = 'code';
        }
        if (!options) {
            options = [];
        }
        return (
            <div className={'SelectNative ' + (error ? classes.error : classes.normal)}>
                {label ?
                    <label data-shrink="true">{label}</label> : ''
                }
                <select id={id} style={{ width: '100%', border: 'none' }} onChange={this.onChange} value={selection || this.state.value}>
                    <option key="sn-none" value="" disabled hidden>{promptText}</option>
                    {options.map(o => {
                        return <option key={'sn-' + o[codeProp]} value={o[codeProp]}>{o[labelProp]}</option>;
                    })}
                </select>
            </div>
        );
    }
}
SelectNative.propTypes = {
    options: PropTypes.array.isRequired,
    labelProp: PropTypes.string,
    promptText: PropTypes.string,
    codeProp: PropTypes.string,
    onChange: PropTypes.func
};
export default (withStyles(styles))(SelectNative);


// WEBPACK FOOTER //
// ./src/ui/SelectNative.js